// extracted by mini-css-extract-plugin
export default {"container":"ErrorAlert_container__+0OeQ","icon":"ErrorAlert_icon__gPpfq","message":"ErrorAlert_message__3hwgC","link":"ErrorAlert_link__T9rUK"};